(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('delivery', {
            // parent: 'entity',
            parent: 'app',
            url: '/delivery?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.delivery.home.title'
            },
            views: {
                // 'content@': {
                'delivery@': {
                    templateUrl: 'app/entities/delivery/deliveries.html',
                    controller: 'DeliveryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery');
                    $translatePartialLoader.addPart('qtyUnitType');
                    $translatePartialLoader.addPart('futuresMonth');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-detail', {
            // parent: 'entity',
            parent: 'app',
            // url: '/delivery/{id}',
            url: '/delivery/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.delivery.detail.title'
            },
            views: {
                // 'content@': {
                'delivery-detail@': {
                    templateUrl: 'app/entities/delivery/delivery-detail.html',
                    controller: 'DeliveryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery');
                    $translatePartialLoader.addPart('qtyUnitType');
                    $translatePartialLoader.addPart('futuresMonth');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery', function($stateParams, Delivery) {
                    return Delivery.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-detail.edit', {
            // parent: 'delivery-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/delivery/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery/delivery-dialog.html',
                    controller: 'DeliveryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery', function(Delivery) {
                            return Delivery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery.new', {
            // parent: 'delivery',
            parent: 'app',
            // url: '/new',
            url: '/delivery/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery/delivery-dialog.html',
                    controller: 'DeliveryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                start: null,
                                end: null,
                                est: null,
                                qty: null,
                                qtyType: null,
                                qtyBales: null,
                                qtyMTs: null,
                                delEstimate: null,
                                payEstimae: null,
                                complete: null,
                                futuresMonth: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery', null, { reload: true });
                }, function() {
                    $state.go('delivery');
                });
            }]
        })
        .state('delivery.edit', {
            // parent: 'delivery',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/delivery/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery/delivery-dialog.html',
                    controller: 'DeliveryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery', function(Delivery) {
                            return Delivery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery.delete', {
            // parent: 'delivery',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/delivery/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery/delivery-delete-dialog.html',
                    controller: 'DeliveryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery', function(Delivery) {
                            return Delivery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
